
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import firebase from "firebase";
import { firebaseEnvironmentKey } from "@/utils/FirebaseKeys";
import { getTokenChat } from "@/services/Chat";
import { Action, Getter } from "vuex-class";
import { ActionMethod } from "vuex";

@Component({
  name: "Chat",
})
export default class Chat extends Vue {
  @Action setChatData!: ActionMethod;
  @Action setChatUri!: ActionMethod;
  @Getter readonly chatToken!: string;
  @Getter readonly expirationDate!: string;
  @Getter readonly whatsUri!: string;
  @Getter readonly chatUri!: string;
  open = false;
  chat = false;
  isWhatsEnabled = false;
  isChatEnabled = false;
  firebaseChatUri =
    "https://chatclaroflex.ilinksolutions.com.br/webchatinit/init";

  get detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  isDateExpirated() {
    if (this.expirationDate && this.expirationDate !== "") {
      const [date, time] = this.expirationDate.split(" ");
      const [day, month, year] = date.split("/").map(Number);
      const [hour, minutes, seconds] = time.split(":").map(Number);
      const today = new Date();
      const limitDate = new Date(year, month - 1, day, hour, minutes, seconds);

      if (today > limitDate) {
        return true;
      }
    }
    return false;
  }

  async updateToken() {
    try {
      const data = await getTokenChat();
      this.setChatData(data);

      this.setChatUri(
        `${this.firebaseChatUri}?token=${data.token}&appOrigem=Flex`
      );
    } catch (error) {
      console.log("Erro ao carregar dados do Chat");
    }
  }

  async validateToken() {
    if (this.chatToken && this.chatToken !== "") {
      if (this.isDateExpirated()) {
        this.updateToken();
      }
    } else {
      this.updateToken();
    }
  }

  @Watch("open")
  async onOpenChanged() {
    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "event",
        eventCategory:
          this.$route.fullPath === "/"
            ? "claro-flex:home"
            : "claro-flex:checkout",
        eventAction: "clique:botao",
        eventLabel: this.open ? "ajuda:abrir" : "ajuda:fechar",
      });
    }
  }

  @Watch("chat")
  async onChatChanged(chatIsOpen: boolean) {
    if (chatIsOpen) {
      this.validateToken();
    }

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "event",
        eventCategory:
          this.$route.fullPath === "/"
            ? "claro-flex:home"
            : "claro-flex:checkout",
        eventAction: "clique:botao",
        eventLabel: this.chat ? "chat:abrir" : "chat:fechar",
      });
    }
  }

  openWhats(): void {
    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "event",
        eventCategory:
          this.$route.fullPath === "/"
            ? "claro-flex:home"
            : "claro-flex:checkout",
        eventAction: "clique:botao",
        eventLabel: "ajuda:whatsapp",
      });
    }
    window.open(this.whatsUri, "_blank");
  }

  async created() {
    const remoteConfig = firebase.remoteConfig();
    await remoteConfig.fetchAndActivate();
    const showWhats = await firebaseEnvironmentKey("show_whatsapp");
    const showChat = await firebaseEnvironmentKey("show_chat");
    this.isWhatsEnabled = remoteConfig.getBoolean(showWhats);
    this.isChatEnabled =
      remoteConfig.getBoolean(showChat) &&
      this.$router.currentRoute.name !== "NcndLink";
    const urlChatPortal = await firebaseEnvironmentKey("url_chat_portal");
    this.firebaseChatUri = remoteConfig.getString(urlChatPortal);
  }
}
